import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      padding: theme.spacing(1.5),
      rowGap: theme.spacing(0.25),
      borderRadius: theme.shape.borderRadius,
      width: '100%',
      '&:hover': {
        backgroundColor: COLORS.gray.gray90,
      },
    },
    type: {
      color: COLORS.gray.gray40,
      textTransform: 'capitalize',
    },
  }),
  { name: 'Item' }
);
